var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('baseBreadcrumb',{attrs:{"page":_vm.$t('message.apiManagement'),"menu":_vm.$t('message.operationAndMaintenance')}}),_c('div',{staticClass:"body"},[_c('iframe',{staticStyle:{"width":"100%"},style:({ height: _vm.tableautoheight + 'px' }),attrs:{"src":"https://apimanage.rakumart.com/operation.apiStats#","frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }